<script>
export default {
  name: 'ContentTreeNode',
  props: {
    node: { type: Object, required: true },
    idPrefix: { type: String, default: '' },
    expandedNodes: { type: Set, required: true },
  },
  emits: ['node-toggle'],
  computed: { stateKey() { return this.idPrefix + 'node-' + this.node.id; } },
};
</script>
<template>
  <details :id="stateKey" :data-node-id="node.id" class="tree-node" :open="expandedNodes.has(stateKey)"
    @toggle.self="$emit('node-toggle', { key: stateKey, open: $event.target.open })">
    <summary><strong>{{ node.title }}</strong><span v-if="node.description">{{ node.description }}</span></summary>
    <div class="tree-children">
      <router-link v-for="content in node.contents" :key="content.id" :to="content.url" class="tree-lesson" :data-content-id="content.id">
        <i :class="['pi', content.type === 'video' ? 'pi-play-circle' : content.type === 'pdf' ? 'pi-file-pdf' : content.type === 'audio' ? 'pi-volume-up' : 'pi-file']"></i>
        <span>{{ content.title }}</span><i class="pi pi-angle-left"></i>
      </router-link>
      <ContentTreeNode v-for="child in node.children" :key="child.id" :node="child" :id-prefix="idPrefix"
        :expanded-nodes="expandedNodes" @node-toggle="$emit('node-toggle', $event)" />
      <p v-if="!node.contents.length && !node.children.length" class="tree-empty">لا يوجد محتوى متاح بعد.</p>
    </div>
  </details>
</template>
<style scoped>
.tree-node { min-width: 0; border: 1px solid #94a3b844; border-radius: .85rem; background: var(--tree-surface); color: var(--tree-text); margin-bottom: .65rem; scroll-margin-top: 6rem; }
summary { cursor: pointer; padding: .85rem; overflow-wrap: anywhere; }
summary span { display: block; font-size: .85rem; margin-top: .3rem; opacity: .8; }
.tree-children { padding: .25rem .8rem .6rem; border-inline-start: 2px solid #94a3b844; margin-inline-start: .7rem; min-width: 0; }
.tree-lesson { display: flex; align-items: center; gap: .65rem; padding: .8rem .6rem; margin-bottom: .4rem; border-radius: .6rem; color: var(--tree-text); text-decoration: none; border: 1px solid #94a3b833; }
.tree-lesson span { flex: 1; min-width: 0; overflow-wrap: anywhere; }
.tree-lesson i { color: var(--tree-accent); flex-shrink: 0; }
.tree-lesson:hover, .tree-lesson:focus-visible { outline: 2px solid var(--tree-accent); }
.tree-empty { padding: .6rem; font-size: .85rem; }
@media (max-width: 600px) { .tree-children { padding-inline: .3rem; margin-inline-start: .3rem; } summary { padding: .7rem .5rem; } }
</style>
